import registrationInstance from './registration/instance'
import { getGlobalStore } from '../../store/globalStore'
import { getLocalStorageRefreshToken } from '../../helper/clientMonitor'
import { getCookieRefreshToken } from '../../helper/cookieToken'
import { setLoginSuccessWithStorageThunk } from '../thunk/registration/auth/withStorage'
import { logger } from '../../logger/logger'

let tokenIsRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

export const refreshAccessToken = () => {
  if (tokenIsRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject })
    })
  }

  tokenIsRefreshing = true

  return registrationInstance.post('/auth/refresh', { 'refreshToken': getCookieRefreshToken() || getLocalStorageRefreshToken() })
    .then(res => {
      getGlobalStore().dispatch(setLoginSuccessWithStorageThunk({
        accessToken: res.data.accessToken,
        refreshToken: res.data.refreshToken,
      }))
      processQueue(null, res.data.accessToken)

      return res.data.accessToken
    })
    .catch(error => {
      logger.error('[auth] Access token refresh failed, status=' + error?.response?.status + ' message=' + error?.message)
      processQueue(error)

      return Promise.reject(error)
    })
    .finally(() => {
      tokenIsRefreshing = false
    })
}
